import React from 'react';
import { Typography, Paper, Box, Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const NotFound: React.FC = () => {
  return (
    <Paper 
      elevation={3} 
      sx={{ 
        p: 4, 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center',
        textAlign: 'center' 
      }}
    >
      <ErrorOutlineIcon sx={{ fontSize: 80, color: 'error.main', mb: 2 }} />
      
      <Typography variant="h4" component="h1" gutterBottom data-testid="not-found-title">
        404 - Page Not Found
      </Typography>
      
      <Typography variant="body1" paragraph sx={{ maxWidth: 600, mb: 4 }}>
        The page you are looking for doesn't exist or has been moved.
        Please check the URL or navigate back to the home page.
      </Typography>
      
      <Button 
        variant="contained" 
        color="primary" 
        component={RouterLink} 
        to="/"
        size="large"
      >
        Back to Home
      </Button>
    </Paper>
  );
};

export default NotFound;